import { api } from '../../../../lib/api'

export const GET_MERCHANT_PRODUCTS_REQUEST = 'GET_MERCHANT_PRODUCTS_REQUEST'
export const GET_MERCHANT_PRODUCTS_SUCCESS = 'GET_MERCHANT_PRODUCTS_SUCCESS'
export const GET_MERCHANT_PRODUCTS_FAILED = 'GET_MERCHANT_PRODUCTS_FAILED'

export const getMerchantProducts = function () {
  return function (dispatch) {
    dispatch({
      type: GET_MERCHANT_PRODUCTS_REQUEST
    })
    api.getMerchantProducts().then(response => {
      dispatch({
        type: GET_MERCHANT_PRODUCTS_SUCCESS,
        payload: response
      })
    }).catch(error => {
      dispatch({
        type: GET_MERCHANT_PRODUCTS_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/merchant/get-merchant-products.js